import React from "react";
import "./aboutUs.css";
import { Link } from "react-router-dom";
// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import VasaviCollegeImg1 from "../../assets/images/vasavi-college.jpg";
// import VasaviCollegeImg2 from "../../assets/images/vasavi-college.jpg";

import VasaviCollegeImg1 from "../../assets/images/Banners/slider-1.jpg";
import VasaviCollegeImg2 from "../../assets/images/Banners/slider-2.jpg";

const AbouttUs = () => {
  // Install modules for Swiper v8
  SwiperCore.use([Navigation, Pagination, Autoplay]);

  const innerPagesSlide = [
    { id: 1, img: VasaviCollegeImg1, alt: "Slide 1" },
    { id: 2, img: VasaviCollegeImg2, alt: "Slide 2" },
  ];

  return (
    <div className="inner-page-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="title-box">
              <h2>About Us</h2>
             
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-lg-8 col-md-8 col-sm-12">
            <div className="row">
              {/* <div className="offset-lg-2 col-lg-8 col-md-12 col-sm-12"> */}
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="slider-box-inner">
                  <Swiper
                    navigation
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    loop={true}
                    spaceBetween={0}
                    slidesPerView={1}>
                    {innerPagesSlide.map((banner) => (
                      <SwiperSlide key={banner.id}>
                        <img
                          src={banner.img}
                          alt={banner.alt}
                          className="img-fluid"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>

            <div className="details-box">
              <h3>Vasavi College of Engineering</h3>
              <p>
                Founded in 1981 by Vasavi Academy of Education, Vasavi College of Engineering represents a rich tradition of excellence in technology-based education. A premier-league institution among the affiliates of Osmania University, Vasavi College of Engineering owes its vision to Sri Pendekanti Venkata Subbaiah, a veteran statesman of Independent India.
              </p>
              <p>
                Vasavi College of Engineering, in its 44 years of existence, is a reputed institution in the State of Telangana. The college is ACCREDITED BY NAAC WITH 'A++' GRADE. The college in its pursuit for quality in technical education has earned 3rd ranking in the State and 32nd in the country (source: Hindustan Times on 24th June 2009).
              </p>
              <p>
                The college offers seven UG (Civil, Mechanical, ECE, CSE, CSE AI & ML, EEE and IT) with total sanctioned intake of 780 and 4 PG programmes [ME (ES & VLSI); ME (ADM); ME(PS & PE); and M.Tech (CSE)] with total sanctioned intake of 48].
              </p>
              <p>
                Located in the sylvan suburbs of Ibrahimbagh in Hyderabad, Vasavi College of Engineering presents a picturesque view flanked by the glorious Golconda Fort. Situated over a sprawling 12.7 acre campus with lush lawns, a beautiful landscape, aesthetic architecture and avant-garde infrastructure, the College epitomizes an exemplary setting for higher learning.
              </p>
              <p>
                With dedicated efforts of over four decades, the College of Engineering has emerged into a centre of excellence in engineering education. Building purposive partnerships with the industry, bolstering its wherewithal continually and evolving innovative programmes consistent with changing times, Vasavi College of Engineering strives to maintain its pre-eminent position.
              </p>
              <p>
                The college has been granted autonomy by the University Grants Commission, New Delhi and Osmania University, Hyderabad for all the programs for a period of six years with effect from 2014-15 and has been extended the autonomous status for a period of ten years from 2021-2022 to 2030-2031.
              </p>
              <p>
                <i>
                  UG (B.E.) Programmes: (Civil Engineering, Computer Science and Engineering, Electrical and Electronics Engineering, Electronics and Communication Engineering Mechanical Engineering) Duration of accreditation : Three years w.e.f. 2024-25 i.e., upto 30.06.2027
                </i>
              </p>
              <p>
                <p>
                  <i>
                    UG (B.E.)Programme: (Information Technology) Duration of accreditation : Two years w.e.f., 2025-26 i.e., upto 30.06.2026.
                  </i>
                </p>
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12">
            <div>
              <div className="sideNav-box">
                <h2>Navigation</h2>

                <ul>
                  <li>
                    <Link href="#">A.I.C.T.E.</Link>
                  </li>

                  <li>
                    <Link href="#">N.B.A.</Link>
                  </li>

                  <li>
                    <Link href="#">N.A.A.C.</Link>
                  </li>

                  <li>
                    <Link href="#">N.I.R.F.</Link>
                  </li>

                  <li>
                    <Link href="#">U.G.C.</Link>
                  </li>

                  <li>
                    <Link href="#">A.I.S.H.E.</Link>
                  </li>

                  <li>
                    <Link href="#">I.Q.A.C.</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AbouttUs;
